import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useUnlinkInterventionMutation = () =>
  useTypedMutation({
    mutationFn: async (intervention_id: number) => {
      await ApiInstance.post("/interventions/unlink", { intervention_id });
    },
    onSuccess: intervention_id => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions) return;

      const { interventions } = appointment;
      const interventionIdx = interventions.findIndex(({ id }) => id === intervention_id);
      if (interventionIdx === -1) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: interventions.with(interventionIdx, { ...interventions[interventionIdx], question_result_id: null })
      });
    }
  });
